import { css, cx } from 'linaria';
import * as React from 'react';
import { states } from '../';

export interface ContextualMenuItem {
    left: string | React.ReactNode;
    right: string | React.ReactNode;
}

export interface ContextualMenuProps {
    menuItems: Array<ContextualMenuItem>;
}

export const ContextualMenu = React.forwardRef<HTMLDivElement, ContextualMenuProps>(
    ({ menuItems, ...passthroughProps }, ref) => {
        return (
            <div ref={ref} className={cx(wrapper)} {...passthroughProps}>
                {menuItems.map((menuItem, index) => (
                    <div key={index} className={cx(menuItemWrapper, states)}>
                        <div className={cx(menuItemLeft)}>{menuItem.left}</div>
                        <div className={cx(menuItemRight)}>{menuItem.right}</div>
                    </div>
                ))}
            </div>
        );
    },
);

ContextualMenu.displayName = 'ContextualMenu';

const wrapper = css`
    z-index: 1;
    position: relative;
    background: #ffffff;

    box-shadow: 0px 7px 8px -4px rgba(16, 16, 16, 0.2), 0px 12px 17px 2px rgba(16, 16, 16, 0.14),
        0px 5px 22px 4px rgba(16, 16, 16, 0.12);
    border-radius: 4px;

    max-height: 300px;
    overflow: auto;
`;

const menuItemWrapper = css`
    position: relative;
    padding: 14px 16px;
    display: flex;
`;

const menuItemLeft = css`
    margin-right: 40px;
    color: #101010;
`;

const menuItemRight = css`
    margin-left: auto;
    color: #666666;
`;
